export const IconPause = () => (
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <g clipPath="url(#icon_pause_clipping_mask)">
      <circle cx="16" cy="16" r="15" stroke="currentColor" strokeWidth="2" />
      <rect
        x="20"
        y="10"
        width="12"
        height="2"
        rx="1"
        transform="rotate(90 20 10)"
        fill="currentColor"
      />
      <rect
        x="14"
        y="10"
        width="12"
        height="2"
        rx="1"
        transform="rotate(90 14 10)"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="icon_pause_clipping_mask">
        <rect width="32" height="32" fill="white" />
      </clipPath>
    </defs>
  </svg>
)
